import { useAppSelector } from 'app/hooks';
import { isCompatibilitySystemPreference } from 'utils/project';

// Reactive twin of isCompatibilitySystemPreference: the Choose Systems
// compatible-combinations pipeline (fetches, filters, rail, comparison grid)
// keys off this, while ductwork-specific Layout & Sizing behavior keeps the
// strict useIsDuctedPathway.
export default function useIsCompatibilityPathway(): boolean {
  return useAppSelector((state) =>
    isCompatibilitySystemPreference(
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
    )
  );
}
